import { render, staticRenderFns } from "./personDetail.vue?vue&type=template&id=4f348adb&scoped=true&"
import script from "./personDetail.vue?vue&type=script&lang=js&"
export * from "./personDetail.vue?vue&type=script&lang=js&"
import style0 from "./personDetail.vue?vue&type=style&index=0&id=4f348adb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f348adb",
  null
  
)

export default component.exports